var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.name,attrs:{"id":_vm.name}},[(!_vm.isSpanishOverride && !_vm.showSlot)?_c(_vm.component,{tag:"component",attrs:{"config":_vm.renderedContent}}):_vm._e(),_vm._v(" "),(_vm.showSlot)?_vm._t("content0",null,{"promoLink":_vm.promoLink}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }